<template>
    <div class="video-items-container" v-if="videoItems != null">
        <div class="video-items">
            <div class="video-item video-item-safety" v-for="item in videoItems" :class="{animate : videoCardAnimate}">
                <!-- :to="'/news/' + cytTolat(item.title)" -->
                <a href="#" class="link-open-modal" @click.prevent="openVideoModal(item.date, item.title, item.video_link)">
                    <svgIcon name="play" class="icon-play"/>
                    <div class="video-item-img">
                        <img :src="item.video_preview" alt="">
                    </div>
                    <div class="video-title">
                        <h2>{{item.title}}</h2>
                    </div>
                </a>
            </div>
        </div>
        <modal name="video-modal" 
            @before-close="beforeVideoModalClose" 
            @closed="videoModalClosed" 
            :transition="transitionName" 
            :width="modalWidth" 
            :height="modalHeight" 
            :scrollable="modalScrollable"  
            class="video-item-modal video-modal-safety"               
            id="video-modal">
            <div class="modal-content" v-if="modalData.date != null && modalData.title != null && modalData.link != null">
                <div class="video-title">
                    <h2>{{modalData.title}}</h2>
                </div>
                <div class="video-player">
                    <iframe :src="modalData.link + '?autoplay=1&loop=1&rel=0&showinfo=0&vq=highres&color=white&iv_load_policy=3'" frameborder="0" allow="autoplay" allowfullscreen></iframe>
                </div>
                <a href="#" class="close-link" @click.prevent="closeVideoModal">
                    <svgIcon name="close" class="icon-close"/>
                </a>
            </div>
        </modal>
    </div>
</template>

<script>
    // var convert = require('cyrillic-to-latin');
    var cyrillicToTranslit = require("cyrillic-to-translit-js")
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'video-item-safety',
        components: {
            svgIcon,
        },
        data () {
            return {
                routerName: this.$router.history.current.name,
                modalWidth: 1000,
                modalHeight: 'auto',
                modalScrollable: false,
                modalData: {
                    date: null,
                    title: null,
                    link: null
                },
                transitionName: 'pop-out',
                videoCardAnimate: true,
            }
        },
        methods: {
            cytTolat(text) {
                return cyrillicToTranslit().transform(text, "_").replace(/!/g,'').replace(/:/g,'').replace(/–/g,'').replace(/-/g,'').replace(/«/g,'').replace(/»/g,'').replace(/,/g,'').toLowerCase();
            },
            correctDate(date) {
                var day = parseFloat(date.slice(8, 10));
                var month = date.slice(5, 7);
                var year = date.slice(0, 4);
                var monthFont;
                var total;
                var monthNames = {
                    '01': { 'kz/': 'Қаңтар', 'en/': 'January', 'default': 'Января' },
                    '02': { 'kz/': 'Ақпан', 'en/': 'February', 'default': 'Февраля' },
                    '03': { 'kz/': 'Наурыз', 'en/': 'March', 'default': 'Марта' },
                    '04': { 'kz/': 'Сәуiр', 'en/': 'April', 'default': 'Апреля' },
                    '05': { 'kz/': 'Мамыр', 'en/': 'May', 'default': 'Мая' },
                    '06': { 'kz/': 'Маусым', 'en/': 'June', 'default': 'Июня' },
                    '07': { 'kz/': 'Шiлде', 'en/': 'July', 'default': 'Июля' },
                    '08': { 'kz/': 'Тамыз', 'en/': 'August', 'default': 'Августа' },
                    '09': { 'kz/': 'Қыркүйек', 'en/': 'September', 'default': 'Сентября' },
                    '10': { 'kz/': 'Қазан', 'en/': 'October', 'default': 'Октября' },
                    '11': { 'kz/': 'Қараша', 'en/': 'November', 'default': 'Ноября' },
                    '12': { 'kz/': 'Желтоқсан', 'en/': 'December', 'default': 'Декабря' }
                };
                monthFont = monthNames[month] ? monthNames[month][this.lang] || monthNames[month]['default'] : '';
                total = day + ' ' + monthFont + ' ' + year;
                return total;
            },
            setFilterNewsLength() {
                if (this.routerName != 'home') {
                    this.$store.commit('filterVideoItems', this.videoItemsDefault);
                }
            },
            startLoader() {
                if (this.routerName == 'home') {
                    this.$parent.$parent.$parent.$refs.topProgress.start();
                } else  {
                    this.$parent.$parent.$refs.topProgress.start();
                }
            },
            openVideoModal(date, title, link) {
                this.modalData.date = date;
                this.modalData.title = title;
                this.modalData.link = link;
                this.$modal.show('video-modal');
                document.getElementsByTagName('body')[0].classList.add('video_open');
            },
            closeVideoModal() {
                this.$modal.hide('video-modal');
                document.getElementsByTagName('body')[0].classList.remove('video_open');
            },
            beforeVideoModalClose() {
                document.getElementsByTagName('body')[0].classList.remove('video_open');
            },
            videoModalClosed() {
                document.getElementsByTagName('body')[0].classList.remove('video_open');
            }
        },
        computed: mapGetters({
            videoItems: 'loadVideoItemsSafety',
        }),
        beforeCreate() {
        },
        created () {
        },
        mounted () {
            // this.setFilterNewsLength();
            // this.$store.watch(
            //     (state) => state.videoItemsFilter,
            //     (newValue) => {
            //         if (newValue) {
            //             this.setFilterNewsLength();
            //         }
            //     }
            // )
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/video/video-items.scss';
    @import '@/styles/respond/video/video-item-respond.scss';
    // @import '@/styles/respond/news/news-item-respond.scss';
</style>